import { FormRestructureEvent } from "../core/";

/**
 * 
 * @param {HTMLFormElement} form 
 */
export function addPopoverRange(form) {
	form.addEventListener("restructure", event => {
		if (!(event instanceof FormRestructureEvent)) return;

		for (const entry of event.added) {
			if (!entry.field) continue;
		
			const range = entry.field.querySelectorAll(":scope input[type='range']");

			range.forEach(rangeItem => {
				const input = /** @type {HTMLInputElement} */ (rangeItem);
				input.addEventListener("input", ev => {
					const target = /** @type {HTMLInputElement} */ (ev.target);
					updateRangeValue(target);
				})
				updateRangeValue(input);
			})

			/**
			 * @param {HTMLInputElement} input 
			 * @returns {[HTMLDivElement, HTMLSpanElement]} The [div, span] elements of the popover content.
			 */
			function createPopover(input) {
				const div = document.createElement("div");
				div.classList.add("range-value");
				const span = document.createElement("span");
				div.appendChild(span);
				input.parentNode?.insertBefore(div, input.nextSibling);
				return [div, span];
			}

			/**
			 * 
			 * @param {EventTarget?} element
			 */
			function updateRangeValue(element) {
				if (!element || !(element instanceof HTMLInputElement)) return;

				let popover = /** @type {HTMLDivElement?} */ (element.parentNode?.querySelector(':scope .range-value'));
				let content = /** @type {HTMLSpanElement?} */ (popover?.firstElementChild);
				if (popover === null) {
					[popover, content] = createPopover(element);
				}

				const min = element.min ? Number.parseInt(element.min) : 0;
				const max = element.max ? Number.parseInt(element.max) : 100;
				const value = element.value ? Number.parseInt(element.value) : 0;
				const newValue = (value - min) * 100 / (max - min);
				const newPosition = 10 - (newValue * 0.2);

				if (popover) {
					popover.style.left = `calc(${newValue}% + (${newPosition}px))`;
				}
				if (content) {
					content.textContent = value.toString();
				}
			}
		}
	});
}